export default defineNuxtPlugin(() => {
  const globalDataSourcesStore = useGlobalDataSourcesStore()

  void globalDataSourcesStore.loadFormOptionsets().catch((error) => {
    console.error('Failed to preload global data sources:', error)
  })
})
